import { theme } from "@/theme";
import { Box, FormControl, Typography } from "@mui/material";
import { Dispatch, SetStateAction, useState } from "react";
import { useTranslation } from "react-i18next";
import { Alert } from "../types";
import TextInputEmail from "./components/text-input-email";

interface Props {
  setAlert: Dispatch<SetStateAction<Alert | undefined>>;
}

const Hero = ({ setAlert }: Props) => {
  const [isLoading, setIsLoading] = useState(false);
  const [email, setEmail] = useState("");
  const { t } = useTranslation();

  const doJoinWaitlist = async () => {
    if (isLoading) return;
    setIsLoading(true);
    try {
      const response = await fetch(
        `https://api.convertkit.com/v3/forms/${process.env.REACT_APP_CONVERTKIT_FORM_ID}/subscribe`,
        {
          body: JSON.stringify({
            email,
            api_key: process.env.REACT_APP_CONVERTKIT_API_KEY,
          }),
          headers: { "Content-Type": "application/json; charset=utf-8" },
          method: "POST",
        }
      );

      if (!response.ok) {
        throw new Error(t("general.error"));
      }

      const { isError, message } = await response.json();

      if (isError) {
        throw new Error(message);
      }

      setEmail("");
      setAlert({
        severity: "success",
        title: t("hero.email.join-waitlist.success"),
      });
    } catch (e) {
      if (e instanceof Error) {
        setAlert({ severity: "error", title: e.message });
      }
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
      }}
    >
      <Box display={"flex"} flexDirection={"column"} flex={1} gap={4}>
        <Box alignSelf={"center"} textAlign={"center"}>
          <Box display={"flex"} flexDirection={"column"} gap={2}>
            <Typography
              variant={"h3"}
              sx={{ color: theme.palette.primary.main }}
              fontWeight={theme.typography.fontWeightBold}
            >
              {t("hero.title.left")}
              <span style={{ color: theme.palette.primary.main }}>{` ${t(
                "hero.title.right"
              )}`}</span>
            </Typography>
            <Typography
              variant={"h5"}
              sx={{ color: theme.palette.primary.main, opacity: 0.38 }}
            >
              {t("hero.subtitle")}
            </Typography>
          </Box>
        </Box>
        <form
          onSubmit={(e) => {
            e.preventDefault();
            doJoinWaitlist();
          }}
        >
          <FormControl variant={"outlined"} fullWidth={true}>
            <Typography variant={"caption"}>
              {t("hero.email.text-input.caption")}
            </Typography>
            <TextInputEmail
              isLoading={isLoading}
              setTextInputValue={setEmail}
              textInputValue={email}
            />
          </FormControl>
        </form>
      </Box>
    </Box>
  );
};

export default Hero;
